/* @ngInject */
const parkCtrl = (
  $scope,
  valueHandler,
  $$wagon,
  $$train,
  $$railway,
  toaster,
  labels
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway

  $scope.displayRailway = false
  $scope.displayTrain = false
  // if (!$$wagon.data.myWagonIds) {
  //   $$wagon.data.myWagonIds = []
  // }

  $scope.addNewWagon = async (_wagon, _train, _sens) => {
    const formattedWagon = $$wagon.format.server(_wagon)

    if (!formattedWagon.isolated) formattedWagon.isolatedComment = null
    if (!formattedWagon.damaged) formattedWagon.damagedComment = null

    try {
      await $$wagon.request.registerOrUpdate(formattedWagon)
      await $$wagon.request.isTrainAlreadyUse(formattedWagon.id, _train.id)

      if ($$wagon.data.myWagonIds.indexOf(formattedWagon.id) !== -1) {
        toaster.error(labels.wagon.log.save.alreadyInList)
      } else {
        if (_sens === 'left') {
          $$wagon.data.myWagonIds.unshift(formattedWagon.id)
        } else {
          $$wagon.data.myWagonIds.push(formattedWagon.id)
        }
        $scope.reinit()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  $scope.parkAllWagons = async (_wagonIds, _railwayId, _trainId, _sens) => {
    if (toaster.confirm(labels.wagon.ask.parkAll(_wagonIds.length))) {
      try {
        const message = await $$wagon.request.park(_wagonIds, _railwayId, _trainId, _sens)
        toaster.message(message)
        $$train.data.myTrain.wagons = await $$train.request.getWagons(_trainId)
        $$wagon.data.myWagonIds = []
        $scope.reinit()
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  $scope.reinit = async () => {
    $scope.wagonForm.$setPristine()
    $scope.wagonForm.$setUntouched()
    $$wagon.data.myWagon = $$wagon.new.classic()

    if (valueHandler.isObject($$railway.data.myRailway)) {
      try {
        const data = {
          railwayId: $$railway.data.myRailway.id,
        }

        const response = await $$wagon.request.getBySearch(data)
        $$railway.data.myRailway.wagons = response.wagons
      } catch (error) {
        toaster.error(error)
      }
    }
  }
}

export default parkCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/park/park.controller.js